import { object } from "yup";

export const DEFAULT_VALUES = {
  product: null,
  variantAttribute1Value: null,
  variantAttribute2Value: null,
  variantAttribute3Value: null,
  variantAttribute4Value: null,
  productVariant: null,
};

export const VALIDATION_SCHEMA = object().shape({
  product: object().required("Produk harus diisi"),
});
